import React from 'react'
import LAChartLine from '../components/Charts/Lakers/LACharLine'


function phoenix_Suns() {
    return (
        <div>
            <LAChartLine/>
        </div>
    )

}

export default phoenix_Suns
